import api from "../index"

const faqsApi = api.injectEndpoints({
  endpoints: (build) => ({
    createFaq: build.mutation({
      query: (body) => ({
        url: `/faqs/create`,
        method: "POST",
        body,
      }),
    }),
    faqList: build.query({
      query: (params) => ({
        url: `/faqs/list`,
        method: "GET",
        params,
      }),
    }),
    faqDelete: build.mutation({
      query: ({ id }) => ({
        url: `/faqs/${id}`,
        method: "DELETE",
      }),
    }),
    getFaq: build.query({
      query: ({ id }) => ({
        url: `/faqs/${id}`,
        method: "GET",
      }),
    }),
    editFaq: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/faqs/${id}`,
        method: "PUT",
        body: { ...rest },
      }),
    }),
  }),
})

export const {
  useCreateFaqMutation,
  useEditFaqMutation,
  useFaqDeleteMutation,
  useLazyFaqListQuery,
  useLazyGetFaqQuery,
} = faqsApi
